import { useMutation, useQueryClient } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryName } from 'reactQueryKeys/reactQueryKeys'
import { updateCardStatus } from 'services/CardService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useUpdateCardStatusMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateCardStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [reactQueryName.CARDS] })
    },
    onError: (error: BaseErrorResponse) => {
      logSentryError('Error: useUpdateCardStatusMutation', error)
    },
  })
}
